import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col, } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

import Logger from '../../functions/logging';

import smallWhitePilotlyLogo from '../../assets/landing/pilotly-white-symbol.png';

import facebookIcon from '../../assets/landing/facebook-social-icon.png';
import twitterIcon from '../../assets/landing/twitter-social-icon.png';

class LandingFooter extends Component {
	handleLinkChange = () => {
		Logger.log(this.constructor.name, "handleLinkChange");
	}

	handleSocialClick = () => {
		Logger.log(this.constructor.name, "handleSocialClick");
	}

	render() {
		return (
			<div className='landing-footer'>
				<Row className='mb-70'>
					<Col className='pt-20' s={12} l={7}>
						<img className='landing-footer-logo gray-scaled' src={smallWhitePilotlyLogo} alt='pilotly logo' />
					</Col>

					<Col s={12} l={5}>
						<Row>
							<Col s={6} l={4}>
								<div className='footer-link-title-container'>
									<p className='footer-link-title'>
										<FormattedMessage
											id="landing_footer.company.title"
											defaultMessage={"Company"}
										/>
									</p>
								</div>
								<div className='footer-link-container'>
									<NavLink to='/register' className='footer-link'>
										<FormattedMessage
											id="landing_footer.join_now.link"
											defaultMessage={"Join Now"}
										/>
									</NavLink>
								</div>
							</Col>
							<Col s={6} l={4}>
								<div className='footer-link-title-container'>
									<p className='footer-link-title'>
										<FormattedMessage
											id="landing_footer.help.link"
											defaultMessage={"Help"}
										/>
									</p>
								</div>
								{/* <div className='footer-link-container'>
									<a className='footer-link'>
										<FormattedMessage
											id="landing_footer.support.link"
											defaultMessage={"Support Desk"}
										/>
									</a>
								</div> */}
								<div className='footer-link-container'>
									<NavLink to='/contact-us' className='footer-link'>
										<FormattedMessage
											id="landing_footer.submit_bug.link"
											defaultMessage={"Submit Bug"}
										/>
									</NavLink>
								</div>
							</Col>
							<Col s={6} l={4}>
								<div className='footer-link-title-container'>
									<p className='footer-link-title'>
										<FormattedMessage
											id="landing_footer.legal.link"
											defaultMessage={"Legal"}
										/>
									</p>
								</div>
								<div className='footer-link-container'>
									<NavLink to='/privacy-policy' className='footer-link'>
										<FormattedMessage
											id="landing_footer.privacy_policy.link"
											defaultMessage={"Privacy Policy"}
										/>
									</NavLink>
								</div>
								<div className='footer-link-container'>
									<NavLink to='/terms-and-conditions' className='footer-link'>
										<FormattedMessage
											id="landing_footer.terms_of_use.link"
											defaultMessage={"Terms of Use"}
										/>
									</NavLink>
								</div>
								{/* <div className='footer-link-container'>
									<a className='footer-link'>
										<FormattedMessage
											id="landing_footer.press.link"
											defaultMessage={"Press / Media"}
										/>
									</a>
								</div> */}
							</Col>
						</Row>
					</Col>

				</Row>

				<Row className='mb-0 valign-wrapper'>
					<Col s={12} m={8}>
						<div className='landing-footer-trademark-container'>
							<p className='landing-footer-trademark-text'>
								<FormattedMessage
									id="landing_footer.trademark"
									defaultMessage={"2019 Pilotly, Inc. All Rights Reserved. Pilotly is a registered trademark of Pilotly Inc."}
								/>
							</p>
						</div>
					</Col>
					<Col s={12} m={4}>
						<div className='landing-footer-socials-container right'>
							<a href='https://twitter.com/pilotlyinsights'><img className='landing-footer-social-icon' src={twitterIcon} alt='twitter icon' /></a>
							<a href='https://www.facebook.com/PilotlyInsights/'><img className='landing-footer-social-icon' src={facebookIcon} alt='facebook icon' /></a>
						</div>
					</Col>
				</Row>
			</div>
		);
	}

}

export default LandingFooter;



// WEBPACK FOOTER //
// ./src/components/landing/LandingFooter.js